<div class="expandable-accordion-container">

  <!-- Header with row count (default template only) -->
  <div class="accordion-header mb-1" *ngIf="showHeader && templateId !== 'recommendations_table' && (data?.rows?.length || showEmptyState)">
    <div class="header-inner">
      <ng-container *ngIf="showSelectAll">
        <input type="checkbox" id="ea-select-all" class="row-checkbox" [(ngModel)]="isSelectAllChecked"
          [disabled]="selectionDisabled"
          (change)="toggleSelectAll()" />
        <label for="ea-select-all" class="select-all-label">Select all</label>
        <span class="header-sep">|</span>
      </ng-container>
      <ng-content select="[accordionSummary]"></ng-content>
      <span class="row-count"><strong>{{ pageStart }}</strong> - <strong>{{ pageEnd }}</strong> of <strong>{{ totalRows }}</strong></span>

      <!-- Pagination arrows — shown when pageSize input is provided -->
      <div class="pagination-div" *ngIf="pageSize > 0">
        <button type="button" class="page-btn" [disabled]="currentPage === 1" (click)="prevPage()" title="Previous page" aria-label="Previous page">
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 1L1 6L6 11"
              [attr.stroke]="currentPage === 1 ? '#D0D2D4' : '#73777E'"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button type="button" class="page-btn" [disabled]="currentPage >= totalPages" (click)="nextPage()" title="Next page" aria-label="Next page">
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L1 11"
              [attr.stroke]="currentPage >= totalPages ? '#D0D2D4' : '#73777E'"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Legacy pagination controls (showPaginationControls flag) -->
      <ng-container *ngIf="showPaginationControls && pageSize === 0">
        <div class="pagination-div">
          <button type="button" class="page-btn" title="Previous page" aria-label="Previous page">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 1L1 6L6 11" stroke="#D0D2D4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button type="button" class="page-btn" title="Next page" aria-label="Next page">
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6 6L1 11" stroke="#73777E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </ng-container>

      <span
        class="header-sep"
        *ngIf="showFilterSortControls && (pageSize > 0 || showPaginationControls)"
      >|</span>

      <!-- Filter and sort icon controls -->
      <ng-container *ngIf="showFilterSortControls">
        <span class="filter-btn-wrap">
          <button
            type="button"
            class="icon-ctrl-btn"
            title="Filter"
            aria-label="Filter"
            (click)="onHeaderAction('filter')"
          >
            <img src="assets/images/virtusa-icons/filter.svg" alt="" />
          </button>
          <span *ngIf="filterActive" class="filter-active-indicator" aria-hidden="true"></span>
        </span>
        <button type="button" class="icon-ctrl-btn" title="Download" aria-label="Download">
          <img src="assets/images/virtusa-icons/doubleArrow.svg" alt="" />
        </button>
      </ng-container>

      <!-- Detail toolbar separator — only when detail icons are shown -->
      <div
        class="divider"
        *ngIf="showFilterButton || showDownloadButton || showDeleteButton"
      ></div>

      <span
        *ngIf="showFilterButton"
        class="filter-btn-wrap"
        matTooltip="Filter"
        matTooltipPosition="below"
        matTooltipClass="custom-tooltip"
      >
        <button class="icon-ctrl-btn" (click)="onHeaderAction('filter')">
          <img src="assets/images/virtusa-icons/filter-light.svg" alt="Filter" />
        </button>
        <span *ngIf="filterActive" class="filter-active-indicator" aria-hidden="true"></span>
      </span>
      <span
        *ngIf="showDownloadButton"
        matTooltip="Download"
        matTooltipPosition="below"
        matTooltipClass="custom-tooltip"
      >
        <button
          class="icon-ctrl-btn"
          [disabled]="selectedRows.size === 0"
          (click)="onHeaderAction('download')"
        >
          <img src="assets/images/virtusa-icons/download-icon.svg" alt="Download" />
        </button>
      </span>
      <span
        *ngIf="showDeleteButton"
        matTooltip="Delete"
        matTooltipPosition="below"
        matTooltipClass="custom-tooltip"
      >
        <button
          class="icon-ctrl-btn"
          [disabled]="selectedRows.size === 0"
          (click)="onHeaderAction('delete')"
        >
          <img src="assets/images/virtusa-icons/delete-red.svg" alt="Delete" />
        </button>
      </span>
    </div>

    <div class="header-actions" *ngIf="showHeaderActions || showAddToSuiteButton || showAddMissingButton">
      <ng-container *ngIf="showHeaderActions">
        <button [style.visibility]="'hidden'" class="header-action-btn" (click)="onHeaderAction('optimized_core_test_cases')">
          <img src="assets/images/virtusa-icons/optimized_core_test_cases.svg" alt="Optimized core test cases icon" />
          Optimized Core Test Cases
        </button>
        <button class="header-action-btn" (click)="onHeaderAction('test_coverage')">
          <img src="assets/images/virtusa-icons/test_coverage.svg" alt="Test coverage icon" />
          Test Coverage
        </button>
      </ng-container>
      <button
        *ngIf="showAddToSuiteButton"
        class="add-to-suite-btn"
        [disabled]="selectedRows.size < 1"
        (click)="onAddToSuiteClick()"
      >
        Add to Test Suite ({{ selectedRows.size }})
      </button>
      <!-- Simple button (non-dropdown) -->
      <button
        *ngIf="showAddMissingButton && !showAddToSuiteButton && !addMissingIsDropdown"
        type="button"
        class="btn-accello-primary-light"
        (click)="onHeaderAction('add_missing')"
      >
        Add Missing Test Cases
      </button>

      <!-- Split dropdown button -->
      <div
        *ngIf="showAddMissingButton && !showAddToSuiteButton && addMissingIsDropdown"
        class="add-missing-dropdown-wrapper"
        (click)="$event.stopPropagation()">
        <button
          type="button"
          class="add-missing-main-btn"
          (click)="addMissingDropdownOpen = !addMissingDropdownOpen">
          + Add Missing Test Cases
          <svg class="add-missing-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="add-missing-menu" *ngIf="addMissingDropdownOpen">
          <button type="button" class="add-missing-menu-item" (click)="onHeaderAction('add_missing'); addMissingDropdownOpen = false">
            Create Test Cases
          </button>
          <button type="button" class="add-missing-menu-item" (click)="onHeaderAction('import_test_cases'); addMissingDropdownOpen = false">
            Import Test Cases
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Accordion rows -->
  <div class="accordion-body">
    <div class="accordion-empty-state" *ngIf="showEmptyState && !data?.rows?.length">
      <app-no-data></app-no-data>
    </div>
    <ng-container *ngFor="let row of data?.rows; let i = index">
    <div
      *ngIf="isRowVisible(i)"
      class="accordion-row"
      [class.expanded]="isExpanded(i)"
    >

      <!-- Row header -->
      <div class="row-main" [class.row-main--static]="!showExpandButton" (click)="toggleRow(i)" (keydown.enter)="toggleRow(i)">
        <!-- Checkbox -->
        <input [hidden]="templateId === 'recommendations_table'" type="checkbox" class="row-checkbox" [attr.id]="'ea-row-checkbox-' + i" [checked]="isSelected(i)"
          [disabled]="selectionDisabled"
          (click)="$event.stopPropagation(); toggleCheckbox(i)" (keydown)="$event.stopPropagation()"
          (change)="$event.stopPropagation()" />
        <label class="visually-hidden" [attr.for]="'ea-row-checkbox-' + i">Select row {{ i + 1 }}</label>
        <div class="row-content">

          <!-- Test case info - show only visible columns -->
          <div class="test-case-info">
            <div [ngClass]="{ 'test-case-description': templateId === 'recommendations_table', 'test-case-header': templateId !== 'recommendations_table' }">
              <ng-container *ngFor="let col of getVisibleColumns()">
                <ng-container *ngIf="shouldShowStoryId(row) && col.mapping_key === 'userStoryId'">
                  <!-- Clickable only when storydesc has content -->
                  <button
                    *ngIf="isStoryIdClickable(row)"
                    type="button"
                    class="story-id"
                    (click)="onStoryIdClick($event, row)"
                    [attr.aria-label]="'View user story ' + (row['userStoryId'] || row['key'])"
                  >{{ row['userStoryId'] || row['key'] }}</button>
                  <!-- Plain text when no story description available -->
                  <span
                    *ngIf="!isStoryIdClickable(row)"
                    class="story-id story-id--static"
                  >{{ row['userStoryId'] || row['key'] }}</span>
                  <span class="story-id-sep"> / </span>
                </ng-container>
                <span class="test-case-id" *ngIf="col.mapping_key === 'testCaseId' || col.mapping_key === 'storyId' || col.mapping_key === 'codeSnippetId'">{{
                  row[col.mapping_key] }} </span>
                <!-- <span
                  class="test-type"
                  *ngIf="(col.mapping_key === 'testType' || col.mapping_key === 'testCaseType') && (row['testType'] || row['testCaseType'])"
                >{{ row['testType'] || row['testCaseType'] }}
                  <span class="sub-type" *ngIf="row.subType">
                    - {{ row.subType }} </span>
                </span> -->

                 <!-- Priority badge - show only if priority column is visible -->
                <span class="priority-badge" *ngIf="col.mapping_key === 'priority' && row[col.mapping_key] && row[col.mapping_key] !== ''"
                  [class]="getPriorityClass(row[col.mapping_key])">
                  {{ getPriorityLabel(row[col.mapping_key]) }}
                </span>

              </ng-container>
              <!-- Star rating for storyId with rciScore -->
              <div class="d-flex align-items-center"
                *ngIf="row.storyId && row.rciScore !== undefined && row.rciScore !== null">
                <span class="status-tag incomplete" *ngIf="row.rciScore < 3">Incomplete</span>
                <span class="status-tag complete" *ngIf="row.rciScore > 2">Completed</span>
              </div>
              <div *ngIf="info.display" class="d-flex align-items-center info-wrapper">
                <!-- Icon here -->
                <img src="assets/images/virtusa-icons/info-gray.png" alt="info" class="info-icon" [title]="info.tooltip"
                  (click)="$event.stopPropagation(); actionEmit.emit({ type: 'infoIcon' })"
                  (keydown.enter)="$event.stopPropagation(); actionEmit.emit({ type: 'infoIcon' })" />
              </div>
            </div>
            <div [ngClass]="{ 'test-case-description': templateId !== 'recommendations_table', 'test-case-header': templateId === 'recommendations_table' }">
              <ng-container *ngFor="let col of getVisibleColumns()">
                <span *ngIf="col.mapping_key === 'testCase' || col.mapping_key === 'summary' || col.mapping_key === 'sourceCodePath' || col.mapping_key === 'sourcecodepath'">
                  <img *ngIf="descriptionImage.prefix?.url" [src]="descriptionImage.prefix?.url" style="margin-right: 6px;" alt="Description icon">
                  <span [style.font-weight]="makeTitleBold ? '600' : null"> {{ row[col.mapping_key]}} </span>
                </span>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center recommendation-count" *ngIf="templateId === 'recommendations_table' && !hideRecommendationCount">
          <img src="assets/images/virtusa-icons/report-gray.png" alt="report">
          <span class="mx-1"> {{ getPaddedCount(getRecommendations(row.recommendations).length || 0) }} Recommendations </span>
        </div>

        <div class="star-rating" *ngIf="row.storyId && row.rciScore !== undefined && row.rciScore !== null">
          <div class="stars">
            <img *ngFor="let star of [1,2,3,4,5]"
              [src]="'assets/images/virtusa-icons/' + (star <= row.rciScore ? (row.rciScore < 3 ? 'star-error' : 'star-green') : 'star') + '.png'"
              alt="">
          </div>
          <span class="rating-text">{{ row.rciScore }}/5</span>
        </div>

        <!-- Action buttons -->
        <div class="row-actions" *ngIf="hasRowActions" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <button *ngIf="showFeedbackActions && row.testCaseId" class="action-btn thumbs-up" [class.clicked]="isThumbsUpClicked(i)"
            data-tooltip="Marks the generated test case as good" (click)="handleAction('thumbs_up', row, i)"
            title="Thumbs up">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.6445 1.27734L12.3047 0.928711L7.88379 5.17773L7.87012 5.19043L7.8584 5.2041C7.46663 5.64035 7.30951 6.13484 7.24805 6.50586C7.21713 6.69257 7.20885 6.85405 7.20898 6.9707C7.20906 7.02915 7.21163 7.07714 7.21387 7.1123C7.21444 7.12128 7.21525 7.12941 7.21582 7.13672V13.1426C7.21587 13.7667 7.47727 14.2914 7.77539 14.584L7.80371 14.6113L7.83496 14.6338C8.11701 14.8355 8.42278 14.9288 8.64258 14.9736C8.75472 14.9965 8.85146 15.0078 8.92188 15.0137C8.9573 15.0166 8.98703 15.0187 9.00879 15.0195C9.01937 15.0199 9.02822 15.0194 9.03516 15.0195C9.03869 15.0196 9.04239 15.0205 9.04492 15.0205H9.0498H9.05078H13.5762C14.8197 15.0205 15.6225 14.7863 16.1328 14.5195C16.3875 14.3863 16.5654 14.2471 16.6855 14.1299C16.7454 14.0714 16.7906 14.0189 16.8232 13.9766C16.8394 13.9556 16.8529 13.9374 16.8633 13.9219C16.8684 13.9142 16.8721 13.9065 16.876 13.9004C16.8779 13.8973 16.8802 13.8943 16.8818 13.8916L16.8848 13.8857L16.8857 13.8848L16.9053 13.8525L16.9189 13.8174L18.8711 8.87891C19.1316 8.25586 19.1414 7.45968 18.582 6.79199H18.5801C18.3181 6.4654 17.9276 6.33529 17.6797 6.2793C17.5426 6.24835 17.4191 6.23317 17.3301 6.22559C17.2854 6.22178 17.248 6.21979 17.2207 6.21875C17.207 6.21823 17.195 6.21793 17.1865 6.21777H12.3389C12.3101 6.21777 12.2907 6.21111 12.2812 6.20605C12.277 6.20373 12.274 6.20167 12.2725 6.2002C12.2711 6.19886 12.2691 6.1962 12.2666 6.19141C12.2394 6.13977 12.2194 6.10175 12.2031 6.06641C12.194 6.04657 12.1887 6.03101 12.1846 6.01953L12.1992 5.97461V5.97363V5.97266C12.1995 5.97166 12.2006 5.96975 12.2012 5.96777C12.2024 5.96382 12.2038 5.95766 12.2061 5.9502C12.2107 5.93464 12.2177 5.91158 12.2266 5.88184C12.2445 5.82194 12.2707 5.73415 12.3037 5.62402C12.3697 5.40362 12.4629 5.09209 12.5723 4.72852C12.7911 4.00084 13.0743 3.06409 13.3311 2.22656L13.3301 2.22559C13.394 2.03883 13.4307 1.84211 13.4307 1.66113C13.4306 1.56742 13.4213 1.46408 13.3926 1.3623C13.3652 1.26523 13.3095 1.13151 13.1904 1.02246L13.0469 0.891602H12.9746C12.9655 0.885921 12.9571 0.878485 12.9473 0.873047C12.8571 0.823507 12.7546 0.795929 12.6445 0.795898V1.27734ZM1.22266 11.7939L1.01367 11.6445C0.664696 11.395 0.5 11.1305 0.5 10.8643C0.500083 10.3679 0.875834 9.98067 1.43848 9.98047C2.00136 9.98047 2.37785 10.3678 2.37793 10.8643C2.37793 11.1747 2.17193 11.4898 1.94043 11.5996L1.65527 11.7344V15.0205H4.81641V6.41602H1.65527V7.80176C1.65527 7.86569 1.63226 7.90708 1.60449 7.93359C1.57553 7.96115 1.52091 7.99121 1.43164 7.99121C1.34274 7.99114 1.28874 7.96107 1.25977 7.93359C1.23199 7.90708 1.20898 7.86569 1.20898 7.80176V6.81348C1.20898 6.41973 1.58478 6.03125 2.04395 6.03125H4.52539C4.9076 6.03131 5.26983 6.336 5.36035 6.9541V14.7178C5.36035 15.1115 4.98451 15.4999 4.52539 15.5H2.05762C1.59321 15.5 1.22266 15.1132 1.22266 14.7178V11.7939ZM6.99219 7.21777L6.96387 7.13672C6.96308 7.13263 6.94646 7.06746 6.94629 6.93164C6.94613 6.79908 6.96124 6.62543 7.00488 6.42578C7.09119 6.03112 7.28675 5.54624 7.68164 5.07812L12.3818 0.561523C12.3858 0.558542 12.3926 0.555027 12.3994 0.550781C12.4135 0.541985 12.4314 0.532683 12.4512 0.524414C12.4708 0.516212 12.4892 0.510718 12.5059 0.506836H12.5469C12.5392 0.506972 12.7389 0.519899 12.9961 0.612305C13.249 0.7032 13.5102 0.853663 13.6885 1.09473V1.0957L13.6943 1.10352C13.8991 1.36838 14.076 1.78653 13.8262 2.51074C13.5154 3.41177 13.1941 4.62841 12.999 5.29492L12.8115 5.93555H17.2812C17.3801 5.93558 18.3874 5.94647 19.0566 6.64258C19.463 7.19847 19.6399 7.92216 19.3721 8.85059L19.3525 8.91797V8.98535L17.332 13.9287L17.2949 14.0195V14.0586C17.2823 14.0876 17.2585 14.1354 17.2168 14.1963C17.1308 14.3217 16.9778 14.4949 16.7246 14.6709C16.2213 15.0207 15.2977 15.3975 13.6797 15.3975H9.05762C8.7129 15.3975 8.13119 15.3157 7.64648 14.9307C7.24713 14.5433 6.99227 13.987 6.99219 13.2314V7.21777Z"
                fill="#73777E" stroke="#73777E" />
            </svg>
          </button>
          <button *ngIf="showFeedbackActions && row.testCaseId" class="action-btn thumbs-down" [class.clicked]="isThumbsDownClicked(i)"
            data-tooltip="Share your feedback so we can update this test case"
            (click)="handleAction('thumbs_down', row, i)">
            <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.8096 0.601562C11.1142 0.601565 11.8581 0.612121 12.4326 1.09863C12.8375 1.51714 13.1034 2.1207 13.1035 2.93555V3.43555H13.2041V9.31445L13.2275 9.38867C13.2281 9.39075 13.2333 9.41071 13.2383 9.45312C13.2435 9.49757 13.2472 9.55694 13.2471 9.62988C13.2467 9.77586 13.2306 9.96518 13.1855 10.1816C13.0962 10.6112 12.8946 11.1338 12.4922 11.6367L7.7666 16.4385C7.76894 16.4361 7.76471 16.4407 7.75195 16.4492C7.73931 16.4576 7.72243 16.4671 7.70312 16.4756C7.66163 16.4939 7.62678 16.5 7.60742 16.5H7.50781C7.52323 16.5 7.32449 16.4877 7.06543 16.3896C6.81323 16.2941 6.54837 16.1334 6.36719 15.873L6.36035 15.8643L6.2832 15.7471C6.11003 15.4534 5.99904 15.0121 6.22461 14.3203C6.53547 13.367 6.85993 12.0705 7.05957 11.3652L7.24023 10.7295H2.75488C2.6634 10.7295 1.62927 10.72 0.958008 9.95703L0.860352 9.84961C0.485824 9.40113 0.379351 8.70011 0.654297 7.57129L0.667969 7.5127V7.44434L2.7002 2.18066L2.7334 2.09375V2.0498C2.734 2.04826 2.73467 2.04664 2.73535 2.04492C2.74875 2.01137 2.77485 1.95659 2.81934 1.8877C2.90761 1.75102 3.0632 1.56612 3.31738 1.37891C3.82122 1.00783 4.74357 0.6084 6.36426 0.608398H6.86426V0.601562H10.8096ZM5.24609 1.04199C4.59861 1.13697 4.12551 1.30885 3.7832 1.49805C3.52643 1.64002 3.34809 1.78847 3.22852 1.91211C3.16896 1.97371 3.12377 2.02825 3.0918 2.07227C3.07585 2.09422 3.06377 2.11393 3.05371 2.12988C3.04868 2.13787 3.04372 2.14509 3.04004 2.15137C3.03827 2.15439 3.03663 2.15755 3.03516 2.16016C3.03445 2.1614 3.03384 2.16291 3.0332 2.16406L3.03125 2.16602C3.03102 2.16644 3.03088 2.16761 3.46973 2.40723L3.03125 2.16699L3.01367 2.19824L3.00195 2.23145L1.03613 7.48047L1.02148 7.51953L1.01367 7.56152C0.964232 7.81945 0.903405 8.1504 0.902344 8.47852C0.901291 8.80716 0.959094 9.1922 1.20117 9.52344C1.46092 9.87884 1.86358 10.0214 2.12207 10.083C2.26145 10.1162 2.38702 10.1325 2.47754 10.1406C2.52313 10.1447 2.56106 10.1463 2.58887 10.1475C2.60273 10.148 2.61434 10.1483 2.62305 10.1484C2.62721 10.1485 2.6309 10.1494 2.63379 10.1494H7.49316C7.51641 10.1494 7.53321 10.1552 7.54199 10.1602C7.54588 10.1624 7.54833 10.1645 7.5498 10.166C7.55112 10.1674 7.55394 10.1701 7.55664 10.1758C7.58393 10.2331 7.60374 10.2738 7.62109 10.3145C7.63642 10.3503 7.64402 10.3751 7.64844 10.3916L7.64062 10.4082L7.62695 10.4561L7.62598 10.457C7.62568 10.4581 7.62558 10.4599 7.625 10.4619C7.62383 10.4661 7.62239 10.4724 7.62012 10.4805C7.61545 10.497 7.60858 10.5219 7.59961 10.5537C7.58164 10.6173 7.55458 10.7101 7.52148 10.8271C7.45522 11.0614 7.36172 11.3927 7.25195 11.7793L6.49121 14.4404C6.43024 14.6351 6.39651 14.8388 6.39648 15.0234C6.39648 15.1179 6.4051 15.221 6.43066 15.3213C6.45447 15.4146 6.50371 15.5489 6.61523 15.6621L6.7627 15.8105H6.83984C6.84899 15.8165 6.85723 15.8244 6.86719 15.8301C6.91012 15.8546 6.95921 15.8768 7.01465 15.8916C7.06985 15.9063 7.12529 15.9121 7.17871 15.9121H7.38867L7.53516 15.7627L11.9805 11.2471L11.9932 11.2334L12.0049 11.2197C12.3881 10.7684 12.5429 10.2877 12.6172 9.93945C12.6256 9.9002 12.6299 9.86048 12.6367 9.82324H12.7461V2.92188C12.7461 2.27792 12.4933 1.72821 12.1875 1.41797L12.1611 1.3916L12.1318 1.36914C11.8479 1.15567 11.5406 1.05605 11.3174 1.00781C11.2036 0.98325 11.1048 0.970231 11.0332 0.963867C10.9974 0.960691 10.9674 0.958911 10.9453 0.958008C10.9344 0.957564 10.9252 0.957172 10.918 0.957031H5.16211L5.24609 1.04199ZM15.4551 0.5H17.9346C18.3735 0.5 18.7783 0.900465 18.7783 1.36328V4.44727L18.9775 4.59668C19.3221 4.85578 19.5 5.14545 19.5 5.45898C19.5 6.032 19.0939 6.43053 18.5566 6.43066C18.0193 6.43066 17.6124 6.03211 17.6123 5.45898C17.6123 5.15385 17.7893 4.86338 18.1396 4.59375L18.335 4.44336V1.07324H15.1621V10.0479H18.335V8.60547C18.335 8.45438 18.425 8.37305 18.5566 8.37305C18.6881 8.37316 18.7783 8.45448 18.7783 8.60547V9.65625C18.7783 10.1191 18.3735 10.5195 17.9346 10.5195H15.4551C15.0161 10.5195 14.6113 10.1191 14.6113 9.65625V1.36328C14.6113 0.900465 15.0161 0.5 15.4551 0.5Z"
                fill="#73777E" stroke="#73777E" />
            </svg>
          </button>
          <span
            *ngIf="showEditButton"
            matTooltip="Edit"
            matTooltipPosition="below"
            matTooltipClass="custom-tooltip"
          >
            <button class="action-btn edit-btn" (click)="handleAction('edit', row, i)">
              <img src="assets/images/virtusa-icons/edit_client.svg" alt="Edit" />
            </button>
          </span>
          <button *ngIf="showExpandButton" class="toggle-button" (click)="toggleRow(i); $event.stopPropagation()" title="Toggle">
            <img *ngIf="isExpanded(i)" src="assets/images/virtusa-icons/remove-outline.svg" alt="remove" />
            <img *ngIf="!isExpanded(i)" src="assets/images/virtusa-icons/add-outline.svg" alt="add" />
          </button>
        </div>
      </div>

      <!-- Expanded content -->
      <div class="row-expanded" *ngIf="isExpanded(i)" [class.has-feedback]="showInlineFeedbackPanel && selectedThumbsDownRow === i">
        <div class="expanded-content">
          <ng-container [ngSwitch]="templateId">

            <!-- Code Review: TC recommendations + code snippet -->
            <ng-container *ngSwitchCase="'recommendations_table'">
              <div class="cr-section" *ngIf="showRecommendations">
                <span class="cr-section-title">
                  Test Case Recommendations ({{ getPaddedCount(getRecommendations(row.recommendations).length || 0) }})
                </span>
                <div *ngFor="let tc of getRecommendations(row.recommendations)" class="cr-tc-card">
                  <span class="cr-tc-desc px-2">{{ tc }}</span>
                </div>
              </div>
              <div class="cr-section" [class.pt-4]="showRecommendations" *ngIf="row.codeSnippets || row.codesnippets">
                <span class="cr-section-title" [hidden]="hideCodeSnippetTitle">Code Snippet</span>
                <app-code-snippet [code]="row.codeSnippets || row.codesnippets"></app-code-snippet>
              </div>
            </ng-container>

            <!-- Default: expandable columns -->
            <ng-container *ngSwitchDefault>
              <div *ngFor="let col of getExpandableColumns()" class="expanded-field">
                <div class="field-label">{{ col.display_name }}</div>
                <div class="field-value" [class.array-value]="Array.isArray(row[col.mapping_key])">
                  <ng-container *ngIf="col.mapping_key === 'qualityReportId'">
                    <div *ngIf="row[col.mapping_key]; else noQrReport" class="quality-report-link"
                      (click)="handleQualityReportClick(row, i)" (keydown.enter)="handleQualityReportClick(row, i)">
                      <img src="assets/images/virtusa-icons/card-expand-icon-blue.svg" class="qr-icon" alt="open report" />
                      <span class="qr-id">{{ row[col.mapping_key] }}</span>
                    </div>
                    <ng-template #noQrReport><span>-</span></ng-template>
                  </ng-container>
                  <ng-container *ngIf="col.mapping_key === 'traceability'">
                    <button
                      *ngIf="row[col.mapping_key]; else noTraceability"
                      type="button"
                      class="traceability-link"
                      (click)="handleTraceabilityClick(row, i)"
                    >
                      {{ getTraceabilityLabel(row[col.mapping_key], getTraceabilityStoryKey(row)) }}
                    </button>
                    <ng-template #noTraceability><span>-</span></ng-template>
                  </ng-container>
                  <ng-container *ngIf="col.mapping_key !== 'qualityReportId' && col.mapping_key !== 'traceability' && Array.isArray(row[col.mapping_key])">
                    <div
                      *ngIf="shouldRenderMarkdown(row[col.mapping_key], col.mapping_key); else arrayPlainList"
                      class="markdown-content"
                      [innerHTML]="row[col.mapping_key] | markdown"
                    ></div>
                    <ng-template #arrayPlainList>
                      <ul class="field-list">
                        <li *ngFor="let item of row[col.mapping_key]">{{ item }}</li>
                      </ul>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="col.mapping_key !== 'qualityReportId' && col.mapping_key !== 'traceability' && !Array.isArray(row[col.mapping_key])">
                    <div *ngIf="row[col.mapping_key]; else noBulletValue">
                      <div
                        *ngIf="shouldRenderMarkdown(row[col.mapping_key], col.mapping_key); else structuredContent"
                        class="markdown-content"
                        [innerHTML]="row[col.mapping_key] | markdown"
                      ></div>
                      <ng-template #structuredContent>
                        <ng-container *ngIf="getProcessedContent(row[col.mapping_key]) as content">
                          <ol *ngIf="content.type === 'numbered'" class="numbered-list">
                            <li *ngFor="let line of content.items">{{ line }}</li>
                          </ol>
                          <ul *ngIf="content.type === 'bullets'" class="bullet-list">
                            <li *ngFor="let line of content.items">{{ line }}</li>
                          </ul>
                          <span *ngIf="content.type === 'plain'" class="preserve-whitespace">{{ row[col.mapping_key] }}</span>
                        </ng-container>
                      </ng-template>
                    </div>
                    <ng-template #noBulletValue><span>-</span></ng-template>
                  </ng-container>
                </div>
              </div>
            </ng-container>

          </ng-container>
        </div>

        <!-- Feedback panel — non-agentic only (agentic routes thumbs-down to chat prompt) -->
        <div
          class="feedback-panel"
          *ngIf="showInlineFeedbackPanel && selectedThumbsDownRow === i"
          (click)="$event.stopPropagation()"
        >
          <div class="feedback-label">Feedback <span class="feedback-required">*</span></div>
          <textarea
            class="feedback-textarea"
            placeholder="Add Feedback"
            [value]="getFeedbackText(i)"
            (input)="setFeedbackText(i, $any($event.target).value)"
            [disabled]="feedbackSubmitting"
            rows="7"
          ></textarea>
          <button
            type="button"
            class="feedback-submit-btn"
            [disabled]="!getFeedbackText(i).trim() || feedbackSubmitting"
            (click)="onUpdateFromFeedback(i, row)"
          >
            {{ feedbackSubmitting ? 'Updating…' : 'Update from Feedback' }}
          </button>
        </div>

      </div>

    </div>
    </ng-container>
  </div>

</div> 